module.exports = __webpack_public_path__ + "static/img/sip.9d599b6d.jpg";